import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-baseline" }
const _hoisted_2 = { class: "user-name me-1" }
const _hoisted_3 = ["title", "href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 0,
  class: "user-name-time ms-auto d-flex"
}
const _hoisted_7 = {
  key: 1,
  class: "error-information"
}
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_dialog = _resolveComponent("modal-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.comment && _ctx.comment.userid)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              target: "_blank",
              rel: "noreferrer noopener",
              title: 'E-Mail an '  + _ctx.username +  ' senden',
              href: _ctx.sanitizeUrl('mailto:' + _ctx.comment.userid.toLowerCase())
            }, _toDisplayString(_ctx.username), 9, _hoisted_3))
          : _createCommentVNode("", true),
        (!_ctx.comment || !_ctx.comment.userid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.username), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "user-name-time" }, "•", -1)),
      _createElementVNode("div", {
        class: "user-name-time ms-1",
        title: _ctx.getTimeString((_ctx.comment && _ctx.comment.timestamp) || '')
      }, _toDisplayString(_ctx.getFromNowString((_ctx.comment && _ctx.comment.timestamp) || '')), 9, _hoisted_5),
      (_ctx.showDeleteButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-mini comment-trash-button",
              title: "Kommentar löschen",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.askDeleteComment && _ctx.askDeleteComment(...args)))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", {
                class: "fa-trash-alt fa-xs far",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "sr-only" }, "Kommentar löschen", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showConfirmDeleteModal)
      ? (_openBlock(), _createBlock(_component_modal_dialog, {
          key: 0,
          buttonTextConfirm: "Kommentar löschen",
          buttonTextCancel: "Abbrechen",
          onConfirm: _ctx.deleteComment,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmDeleteModal = false))
        }, {
          header: _withCtx(() => [...(_cache[4] || (_cache[4] = []))]),
          body: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Sind Sie sicher, dass dieser Kommentar gelöscht werden soll?", -1)
          ]))]),
          _: 1
        }, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, "Fehler:"),
            _createTextVNode(" Beim Löschen des Kommentars ist ein unerwarteter Fehler aufgetreten. ")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.bodyClass),
      innerHTML: _ctx.commentTextSanitized
    }, null, 10, _hoisted_8)
  ], 64))
}